import React, { FC } from "react";
import "./index.scss";
import { InputProps } from "@shared/interfaces";

export const Radio: FC<InputProps> = (props) => {
  const { name, value, children, defaultChecked = false, onChange, ...inputProps } = props;
  return (
    <label className="radio-button">
      <input
        type="radio"
        name={name}
        value={value}
        defaultChecked={defaultChecked}
        onChange={onChange}
        {...inputProps}
      />
      <span>{children}</span>
    </label>
  );
};

export default Radio;
